
import { computed, defineComponent, PropType, ref } from 'vue';
import { OioInput, OioButton, OioNotification } from '@kunlun/vue-ui-antd';

export type SendStatus = 'unsend' | 'sending' | 'sended';

export default defineComponent({
  name: 'SendVerifyCode',
  components: {
    OioInput,
    OioButton
  },
  props: {
    sendCode: {
      type: Function as PropType<() => Promise<Record<string, unknown>>>,
      default: () => {}
    },
    onInput: {
      type: Function as PropType<(value: InputEvent) => void>,
      default: () => {}
    }
  },
  setup(props) {
    const code = ref('');
    const sendTimes = ref(0);
    const leftSeconds = ref(60);
    const sendStatus = ref<SendStatus>('unsend');
    let interval;

    const loading = computed(() => sendStatus.value === 'sending');
    const disabled = computed(() => sendStatus.value === 'sended');

    const sendStatusStr = computed(() => {
      const statusMap: Record<SendStatus, string> = {
        unsend: sendTimes.value ? '重新发送' : '发送验证码',
        sending: '发送中',
        sended: `重新发送(${leftSeconds.value})`
      };
      return statusMap[sendStatus.value];
    });

    const startCountdown = () => {
      interval = setInterval(() => {
        leftSeconds.value--;
        if (leftSeconds.value === 0) {
          clearInterval(interval);
          sendStatus.value = 'unsend';
          leftSeconds.value = 60;
        }
      }, 1000);
    };

    const onSend = async () => {
      if (sendStatus.value === 'unsend') {
        sendStatus.value = 'sending';
        try {
          const res = await props.sendCode();
          if (res.broken) {
            OioNotification.error('错误', res.errorMsg as string);
          }
          if (res.errorMsg === '该手机号已经被使用') {
            sendStatus.value = 'unsend';
            leftSeconds.value = 60;
            sendTimes.value++;
            return;
          }
          sendStatus.value = 'sended';
          sendTimes.value++;
          startCountdown();
        } catch (error) {
          console.error(error);
          sendStatus.value = 'unsend';
        }
      }
    };

    return {
      code,
      leftSeconds,
      sendStatus,
      loading,
      disabled,
      sendStatusStr,
      onSend
    };
  }
});
